import React, { useEffect } from "react";
import "./Tapovan_Arpanam.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import Yellow_Btn from "../../common/common_btn/yellow_btn/Yellow_Btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UPcomingFestival } from "../../../features/admin/common/Slice";
import { diffInDays, encodeId, formatEventDate, formatTime } from "../../../utils/common";
import { IDS } from "../../../utils/IDS";

const Tapovan_Arpanam = () => {

  const navigate = useNavigate();


  const dispatch = useDispatch();

  const event = useSelector((state) => state.common.coming_festival);

  useEffect(() => {
    dispatch(UPcomingFestival());
  }, [dispatch])


  return (
    event?.id && (

      <section className="Tapovan_Arpanam">
        <div className="container">
          <div className="main_card_div">
            <div className="bg_img_holder">
              <img
                src={IDS.IMG_URL + event?.Event?.image}
                // src={"/assets/images/home/tapovan_arpanam/div_bg.png"}
                className="bg_img"
              />
            </div>
            <div className="content_div conatiner">
              <div className="top_div">
                <p className="first_text">
                  <span className="inner_text">{diffInDays(event?.Event?.start_date, event?.Event?.end_date) || "1"} Days </span> {event?.name || " "}
                </p>
                <p className="second_text">{event?.subname || " "}</p>
              </div>

              <div className="bottom_div">
                <div className="date_text_div">
                  <FontAwesomeIcon icon={faCalendarDays} className="date_text" />
                  {formatEventDate(event?.Event?.start_date, event?.Event?.end_date) || "1"} at {formatTime(event?.Event?.start_time) || ""}
                </div>
                <div className="btn_holder">
                  <Yellow_Btn btnText={"Regsiter Now"} onClick={() => (navigate(`/shibir-registration/${encodeId(event?.event_id)}`))} className="zoom_in_out" />
                </div>
              </div>
            </div>
            <div className="overlay"></div>
          </div>
        </div>
      </section>
    )
  );
};

export default Tapovan_Arpanam;
